export default __webpack_public_path__ + "static/media/smartek.71d44aae.svg";